// extracted by mini-css-extract-plugin
export default {"topbar":"AqRXd2IJ","block":"wzv0klUG","marks":"jQaDtZas"};